import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { DelegationsAdminPage } from '../../../features/approvals/monitor/delegations-page'
import { delegationAdminSearchSchema } from '../../../features/approvals/monitor/search'

export const Route = createFileRoute('/_app/workflows/delegations')({
  staticData: { crumb: 'approvalDelegations' },
  validateSearch: delegationAdminSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'workflows.delegations'),
  component: DelegationsAdminPage,
})
